<template>
  <div class="workload-page">
    <el-form class="search-head" :inline="true" label-position="left">
      <el-form-item label="账号">
        <el-input v-model="form.username" />
      </el-form-item>
      <el-form-item label="姓名">
        <el-input v-model="form.accountName" />
      </el-form-item>
      <el-form-item label="项目">
        <el-select
          v-model="form.projectId"
          placeholder="请选择项目"
          clearable
          filterable
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="统计时间">
        <el-date-picker
          v-model="form.date"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
        />
      </el-form-item>

      <el-form-item class="search-group">
        <el-button type="primary" @click="search">查询</el-button>
        <el-button @click="resetForm">重置</el-button>
      </el-form-item>
    </el-form>
    <div class="tabel-box">
      <el-table
        v-loading="listLoading"
        stripe
        style="width:100%"
        border
        :data="tableData"
      >
        <el-table-column prop="username" label="账号" />
        <el-table-column prop="name" label="姓名" />
        <el-table-column prop="projectName" label="项目" />
        <el-table-column prop="uploadFile" label="上传材料总量" />
        <el-table-column prop="checkCount" label="审核材料" />
        <el-table-column prop="checkPhase1" label="首次审核材料" />
        <el-table-column prop="checkPhase0" label="后续审核材料" />
        <el-table-column prop="receiveCount" label="物流材料" />
        <el-table-column prop="checkPatient" label="上传患者-审核" />
        <el-table-column prop="receivePatient" label="上传患者-物流" />
        <el-table-column prop="editFile" label="指定材料" />
        <el-table-column prop="editPatient" label="指定患者" />
        <el-table-column label="操作" width="120">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="watch(scope.row)"
            >查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="button-handle">
        <el-button
          type="primary"
          :loading="downloadLoading"
          @click="handleDownload"
        >导出</el-button>

        <pagination
          v-show="total > 0"
          :total="total"
          :page.sync="listQuery.pageIndex"
          :limit.sync="listQuery.pageSize"
          @pagination="getList"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { logpage, detailPage } from '@/api/work'
import { projectquery } from '@/api/user'
import Pagination from '@/components/Pagination'
export default {
  inject: ['reload'],
  components: { Pagination },
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(
                start.getTime() - 3600 * 1000 * 24 * 7
              )
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(
                start.getTime() - 3600 * 1000 * 24 * 30
              )
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(
                start.getTime() - 3600 * 1000 * 24 * 90
              )
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      listLoading: false,
      firstSearch: null,
      listQuery: {
        pageIndex: 1,
        pageSize: 20
      },
      form: {
        username: null,
        accountName: null,
        projectId: null,
        date: null
      },
      total: 0,
      options: [],
      tableData: [],
      downloadLoading: false
    }
  },
  watch: {
    $route(to, form) {
      this.firstLoad()
    }
  },
  created() {
    this.firstLoad()
    projectquery().then(res => {
      this.options = res.data
    })
  },
  methods: {
    resetForm() {
      this.firstSearch = {
        userName: null,
        accountName: null,
        projectId: null,
        begTime: null,
        endTime: null,
        pageIndex: 1,
        pageSize: 20
      }
      this.form = {
        username: null,
        accountName: null,
        projectId: null,
        date: null
      }
      this.listQuery.pageIndex = 1
      this.listQuery.pageSize = 20
      this.initData(this.firstSearch)
      this.$router.replace({ query: null })
    },
    firstLoad() {
      if (this.$route.query.hasOwnProperty('begTime')) {
        this.firstSearch = { ...this.$route.query }
        delete this.firstSearch.id
        this.listQuery = {
          pageIndex: this.firstSearch.pageIndex * 1,
          pageSize: this.firstSearch.pageSize * 1
        }
        this.form = {
          username: this.firstSearch.username,
          accountName: this.firstSearch.accountName,
          projectId: this.firstSearch.projectId
            ? this.firstSearch.projectId * 1
            : null,
          date: this.firstSearch.begTime
            ? [
              new Date(this.firstSearch.begTime * 1),
              new Date(this.firstSearch.endTime * 1)
						  ]
            : null
        }
        console.log('this.form', this.form)
      } else {
        this.firstSearch = {
          userName: null,
          accountName: null,
          projectId: null,
          begTime: new Date().getTime(),
          endTime: new Date().getTime() - 3600 * 1000 * 24 * 7,
          pageIndex: 1,
          pageSize: 20
        }
        this.form = {
          username: null,
          accountName: null,
          projectId: null,
          date: [this.firstSearch.endTime, this.firstSearch.begTime]
        }
      }

      this.initData(this.firstSearch)
    },
    initData(data) {
      this.listLoading = true
      logpage(data)
        .then(res => {
          this.tableData = res.data.records
          this.total = res.data.total
          setTimeout(() => {
            this.listLoading = false
          }, 100)
        })
        .catch(err => {
          this.listLoading = false
        })
    },
    getList() {
      this.firstSearch.pageIndex = this.listQuery.pageIndex
      this.firstSearch.pageSize = this.listQuery.pageSize
      this.initData(this.firstSearch)
    },
    search() {
      this.firstSearch.userName = this.form.username
        ? this.form.username.trim()
        : null
      this.firstSearch.accountName = this.form.accountName
        ? this.form.accountName.trim()
        : null
      this.firstSearch.projectId = this.form.projectId
      this.firstSearch.begTime = this.form.date
        ? this.form.date[0].getTime()
        : null
      this.firstSearch.endTime = this.form.date
        ? this.form.date[1].getTime()
        : null
      this.listQuery.pageIndex = 1
      this.initData(this.firstSearch)
      var query = JSON.parse(JSON.stringify(this.firstSearch))
      query.id = Math.random()
      this.$router.replace({ query: query })
    },
    // 查看
    watch(row) {
      this.$router.push({
        name: 'seeworkload',
        params: {
          accountId: row.accountId,
          projectId: row.projectId
        }
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },
    handleDownload() {
      this.downloadLoading = true
      console.log(this.firstSearch, '')
      const datas = { ...this.firstSearch }
      datas.pageSize = 1000

      logpage(datas).then(res => {
        const arr = res.data.records
        console.log('arr', arr)
				import('./table').then(excel => {
				  const tHeader = [
				    '账号',
				    '姓名',
				    '项目',
				    '上传材料总量',
				    '审核材料',
				    '首次审核材料',
				    '后续审核材料',
				    '物流材料',
				    '上传患者-审核',
				    '上传患者-物流',
				    '指定材料',
				    '指定患者'
				  ]
				  const filterVal = [
				    'username',
				    'name',
				    'projectName',
				    'uploadFile',
				    'checkCount',
				    'checkPhase1',
				    'checkPhase0',
				    'receiveCount',
				    'checkPatient',
				    'receivePatient',
				    'editFile',
				    'editPatient'
				  ]
				  const data = this.formatJson(filterVal, arr)
				  excel.export_json_to_excel({
				    header: tHeader,
				    data,
				    filename: '工作量统计'
				  })
				  this.downloadLoading = false
				})
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.workload-page {
	.search-head {
		padding: 0 30px;
	}
	.tabel-box {
		padding: 20px 30px;
	}
	.button-handle {
		margin-top: 30px;
		display: flex;
		align-items: center;
	}
}
@media (max-width: 1920px) {
	.search-group {
		float: right;
		margin-right: 100px;
	}
}
@media (max-width: 992px) {
	.search-group {
		float: right;
		margin-right: 120px;
	}
}
@media (max-width: 768px) {
	.search-group {
		float: left;
	}
}
</style>
<style lang="scss">
.button-handle {
	.pagination-container {
		margin-top: 0px;
	}
}
</style>
